import { render, staticRenderFns } from "./ToolOrderDetails.vue?vue&type=template&id=6d581aed&scoped=true&"
import script from "./ToolOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ToolOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ToolOrderDetails.vue?vue&type=style&index=0&id=6d581aed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d581aed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VCard,VCardText,VChip,VIcon,VSimpleTable})
